module.exports = __webpack_public_path__ + "img/loader.8a6ee833.svg";